import { useEffect, useState } from "react";
import close from '../../../public/assets/images/srp/close.svg';
import downArrow from '../../../public/assets/images/down-arrow.svg';
import { trackButtonClick } from "@/utils/analytics";
import { getSrpLocationLabel } from "@/utils/filterTrackingService";

const FilterSingleItem = ({panelId, skipIndex, propertyName, propertiesItem, disabledFilter, onClick, onClearPress, selectedList = [], isMobView = false}) => {
  const [show, setShow] = useState(false)

 useEffect(() => {
   const handleClick = (event) => {
     const panelBtn = document.getElementById(`${panelId}${isMobView ? '-M' : ''}-btn`);
     const panelArea = document.getElementById(`panelBody${panelId}${isMobView ? '-M' : ''}`);
     if (
       (panelBtn && panelBtn.contains(event.target) && !show) ||
       (panelArea && panelArea.contains(event.target))
     ) {
       setShow(true);
       // Track dropdown open event
       if (!show) {
         if (!window._processingStateOpen) {
           window._processingStateOpen = true;

           trackButtonClick({
             eventName: "filter_dropdown_open",
             eventParams: { property_name: propertyName },
             eventSource: "Dropdown Interaction",
             eventCategory: "NEW-SRP",
             eventLabel: `Location: ${getSrpLocationLabel()}`,
           });

           // Reset the processing flag after a short delay
           setTimeout(() => {
             window._processingStateOpen = false;
           }, 300);
         }
       }
     } else {
       setShow(false);
     }
   };

   document.addEventListener("click", handleClick);

   // Clean up the event listener when component unmounts or dependencies change
   return () => {
     document.removeEventListener("click", handleClick);
   };
 }, [show, panelId, propertyName]);


  const propertyCount = selectedList?.length || 0;

  const filteredList = propertiesItem.map(item => {
    let isChecked = false;
    selectedList.forEach(selectedItem => { if (selectedItem === item.uiurl) { isChecked = true }});
    if (isChecked) {
      return {...item, isChecked: true}
    } else {
      return {...item, isChecked: false}
    }
  });

  return (
    <li id={`${panelId}${isMobView ? '-M' : ''}`} className={isMobView ? "" : "list-inline-item menu-item-container"} key={`filter-item-${panelId}${isMobView ? '-M' : ''}-${propertyName}`}>
      <div className="panel-group">
        <div className="panel">
          <div className="panel-heading">
            <h4 className="panel-title">
              <div
                className="selectpicker w100 filter-menu"
                id={`${panelId}${isMobView ? '-M' : ''}-btn`}
              >
                <span className={`filter-menu-title ${propertyCount > 0 ? 'filter-menu-selected' : ''}`}>
                  {propertyName}
                  {propertyCount > 0 && <span className={`${propertyCount > 0 ? 'filter-menu-count' : ''}`}> {` (${propertyCount})`}</span>}
                </span>
                <div className="filter-menu-arrow" onClick={(e) => {
                  if (propertyCount > 0) {
                    onClearPress();
                    e.stopPropagation();
                    e.preventDefault();
                  }
                }}>
                  <img src={propertyCount > 0 ? close : downArrow} className={propertyCount > 0 || show ? "arrow-up" : "arrow-down"} height="10" width="11" alt="arrow" />
                </div>
              </div>
            </h4>
          </div>
          {show && <div id={`panelBody${panelId}${isMobView ? '-M' : ''}`} className={`panel-collapse collapse ${isMobView ? '' : 'panel-model'}`} style={{display: 'block'}}>
            <div className="panel-body row">
              <div className="col-lg-12">
                <ul className="ui_kit_checkbox selectable-list fn-400">
                  {filteredList?.map((feature, index) => {
                    if (skipIndex === index) {
                      return null;
                    }
                    const disabled = disabledFilter && disabledFilter[feature.fieldIDUI] && disabledFilter[feature.fieldIDUI].length > 0 && disabledFilter[feature.fieldIDUI].filter(disabledFilter => disabledFilter === feature.uiurl).length > 0;
                    if (disabled) {
                      let addressBarURL = new URL(window.location.href)
                      if (addressBarURL.searchParams.has(feature.fieldIDUI, feature.uiurl)) {
                        addressBarURL.searchParams.delete(feature.fieldIDUI, feature.uiurl);
                        history.pushState({}, "", addressBarURL.href)
                      }
                    }
                    return (
                      <li key={`filter-option-${feature.uiurl}`} className={isMobView ? "" : "checkbox-list panel-option"} onClick={() => !disabled && onClick(feature)}>
                        <div className="form-check custom-checkbox">
                          <input
                            type="checkbox"
                            className="form-check-input mt0"
                            aria-label={feature.displayname}
                            id={feature.displayname}
                            value={feature.uiurl}
                            checked={feature.isChecked || false}
                            onChange={() => onClick(feature)}
                            onClick={() => onClick(feature)}
                            disabled={disabled}
                          />
                          <label className="form-check-label w100 checkbox-label" htmlFor={feature.uiurl}>
                            {feature.displayname}
                          </label>
                        </div>
                      </li>
                    )}
                  )}
                </ul>
              </div>
            </div>
          </div>}
        </div>
      </div>
    </li>
  );
};

export default FilterSingleItem;
